'use client';

import { usePathname } from 'next/navigation';
import React from 'react';
import { newDate } from '../../../../utils';
import styles from './TradeNote.module.scss';

export type TradeNoteProps = {
  tradeAt?: string;
};

const TradeNote = ({ tradeAt }: TradeNoteProps) => {
  const pathname = usePathname();

  const formatTradeDate = (tradeAtValue?: string) => {
    if (!tradeAtValue) return 'YYYY年MM月DD日 XX:XX';

    const date = newDate(tradeAtValue);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
  };

  const notes = [];

  // /cancelCompleteページにいない場合のみ、取り消し可能の文を追加
  if (!pathname.includes('/cancelComplete')) {
    notes.push('期間内であれば景品交換の取り消しは可能です。');
  }

  notes.push(`景品交換可能期間：　${formatTradeDate(tradeAt)}まで`, '景品交換可能期間外の変更受付は不可となります。');

  return (
    <div className={styles.tradeNoteContainer}>
      <h3 className={styles.tradeNoteTitle}>【注意事項】</h3>
      <ul className={styles.tradeNoteList}>
        {notes.map((note) => (
          <li key={note} className={styles.tradeNoteItem}>
            {note}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TradeNote;
